import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { gql } from '@src/lib/gql';
import { useRouter } from 'next/navigation';
import React from 'react';
export const RequestDeleteForm: React.FC<{
  groupRequestId: string;
}> = props => {
  const $ = _c(11);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
    mutation ($input: UpsertGroupRequestInput!) {
      upsertGroupRequest(input: $input) {
        groupRequest {
          id
          groupRequestId
          deletedAt
        }
      }
    }
  `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [upsertGroupRequest, upsertGroupRequestMutation] = useMutation(t0);
  let t1;
  if ($[1] !== props.groupRequestId || $[2] !== router || $[3] !== upsertGroupRequest) {
    t1 = async ev => {
      ev.preventDefault();
      if (confirm("Are you sure you want to delete this Request?")) {
        await upsertGroupRequest({
          variables: {
            input: {
              groupRequestId: props.groupRequestId,
              deletedAt: new Date()
            }
          }
        });
        router.push("/requests");
      }
    };
    $[1] = props.groupRequestId;
    $[2] = router;
    $[3] = upsertGroupRequest;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleSubmit = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box><Heading size="md">Delete</Heading><Text color="fg.muted">Deleting this request will also clear your game plan, matches, and all related activity.</Text></Box>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== upsertGroupRequestMutation.loading) {
    t3 = <VStack align="stretch" gap={4} width="full">{t2}<Button colorPalette="red" loading={upsertGroupRequestMutation.loading} loadingText="Deleting, please wait..." size="lg" type="submit" variant="solid" width="full">Delete this Request</Button></VStack>;
    $[6] = upsertGroupRequestMutation.loading;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleSubmit || $[9] !== t3) {
    t4 = <Box bgColor="bg.error/30" borderColor="border.error" borderRadius="md" borderWidth="1px" padding={6}><form onSubmit={handleSubmit}>{t3}</form></Box>;
    $[8] = handleSubmit;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};